


































import { TypeBody, TypeHeading } from '@bambeehr/pollen';
import {
  computed,
  defineComponent,
  PropType,
  ref,
  onMounted,
  onUnmounted,
} from '@nuxtjs/composition-api';
import { IBusinessInformation } from '../index';

export default defineComponent({
  components: {
    TypeBody,
    TypeHeading,
  },
  props: {
    information: {
      type: Object as PropType<IBusinessInformation>,
      default: () => ({
        name: 'Hannah Olinger',
        businessName: 'Banana Coffee Shop',
        numberOfEmployees: '32',
      }),
    },
  },

  setup(props) {
    const windowWidth = ref(window.innerWidth);
    const isLargeScreen = computed(() => {
      return windowWidth.value >= 1024 && true;
    });

    onMounted(() => {
      window.addEventListener('resize', () => {
        windowWidth.value = window.innerWidth;
      });
    });
    onUnmounted(() => {
      window.removeEventListener('resize', () => {
        windowWidth.value = window.innerWidth;
      });
    });

    const isBusinessName = computed(
      () => props.information.businessName !== '' || !isLargeScreen
    );

    return {
      isLargeScreen,
      isBusinessName,
    };
  },
});
